<template>
  <div>
    <wc-data-box
      title="Sales Notes"
      :titleIcon='titleIcon'
      :titleIconColor='titleIconColor'
      :showEdit='showEdit'
      @edit='edit'
    >
      <template v-slot:toolbarButtons >
        <span v-if='showPendingSaveText' class='mr-1 primary--text font-italic font-weight-bold'>(Pending Save)</span>
      </template>
      <v-card-text v-if='!project.sales_notes' class='font-italic grey--text text--lighten-2'>None...</v-card-text>
      <v-card-text v-else v-html='project.sales_notes'></v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      title='Edit Sales Notes'
      width='600'
      :saveText='saveText'
      @cancel='cancel'
      @save='save'
    >
      <vue-editor :editor-toolbar='customToolbar' v-model='projectCopy.sales_notes'></vue-editor>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'snow-sales-notes',
  props: {
    project: {
      required: true
    },
    showEdit: {
      required: false,
      type: Boolean,
      default: true
    },
    showPendingSaveText: {
      required: false,
      type: Boolean,
      default: false
    },
    saveText: {
      required: false,
      type: String,
      default: "Save"
    },
    titleIcon: {
      required: false,
      type: String,
      default: "mdi-note-outline"
    },
    titleIconColor: {
      required: false,
      type: String,
      default: "info"
    }
  },
  data: () => ({
    isLoading: false,
    showDialog: false,
    projectCopy: {},
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }]
    ],
  }),
  computed: {
    
  },
  methods: {
    edit () {
      this.projectCopy = _.cloneDeep(this.project)
      this.showDialog = true
    },
    cancel () {
      this.showDialog = false
    },
    save () {
      this.$emit('update', this.projectCopy)
      this.cancel()
    }
  },
  components: {
    'vue-editor': VueEditor
  }
}
</script>